import React, { createContext, useContext, useMemo, useState } from 'react';

const I18nContext = createContext({ t: (k) => k, lang: 'en', setLang: () => {} });

const dict = {
  en: {
    // Landing / Auth
    'land.nav.features': 'Features',
    'land.nav.pricing': 'Pricing',
    'land.nav.login': 'Log in',
    'land.nav.startFree': 'Start free',
    'land.nav.downloads': 'Downloads',
    'land.hero.badge': 'Profit OS for SMB owners',
    'land.hero.title': 'Run billing, expenses & reports in one place.',
    'land.hero.p1': 'TrackProfit replaces paper books with a real-time profit console across web, mobile apps and WhatsApp.',
    'land.hero.p2': 'Close sales faster, understand cash flow and make confident decisions in minutes.',
    'land.hero.cta.start': 'Start free',
    'land.hero.cta.login': 'Log in',
    'land.hero.cta.whatsapp': 'Try WhatsApp Assistant for Free',
    'land.hero.cta.download': 'Download apps',
    'land.hero.whatsapp.number': '+91 95432 68625',
    'land.hero.whatsapp.demo': 'See how it works',
    'land.hero.platform.web': 'Web dashboard',
    'land.hero.platform.android': 'Android APK',
    'land.hero.platform.windows': 'Windows app',
    'land.hero.platform.whatsapp': 'WhatsApp assistant',
    'land.hero.cards.today': "Today's Profit",
    'land.hero.cards.total': 'Total Profit',
    'land.hero.cards.orders': 'Orders',
    'land.hero.cards.caption': 'Your business overview',
    'land.hero.stats.orders': 'Orders this week',
    'land.hero.stats.expenses': 'Expenses tracked',
    'land.hero.stats.cash': 'Cash collected',
    'land.download.badge': 'New native apps',
    'land.download.title': 'Download TrackProfit for Android & Windows',
    'land.download.subtitle': 'Install the native experience for lightning-fast billing, offline-ready data, and direct printer support.',
    'land.download.android.badge': 'APK',
    'land.download.android.title': 'Android APK',
    'land.download.android.desc': 'Perfect for business owners on the move. Works offline and syncs the moment you are online.',
    'land.download.windows.badge': 'Desktop',
    'land.download.windows.title': 'Windows App (.exe)',
    'land.download.windows.desc': 'Full-sized experience with keyboard shortcuts and USB/Bluetooth printer support.',
    'land.download.metric.size': 'Approx. size',
    'land.download.metric.requirement': 'Requires',
    'land.download.cta.android': 'Download APK',
    'land.download.cta.windows': 'Download EXE',
    'land.download.comingSoon': 'Link coming soon',
    'land.download.helperSoon': 'We will drop the download link right after publishing the next release.',
    'land.download.helper': 'Need Mac or iOS? Ping us on WhatsApp and we will guide you.',
    'land.features.profit.title': 'Real-time profit',
    'land.features.profit.desc': "See if you're making money today.",
    'land.features.orders.title': 'Track orders',
    'land.features.orders.desc': 'Simple order entry, fast and clear.',
    'land.features.expenses.title': 'Track expenses',
    'land.features.expenses.desc': 'Know your costs without the accounting mess.',
    'land.features.quick.title': '2–5 mins/day',
    'land.features.quick.desc': 'Enter transactions daily; we do the math.',
    'land.features.whatsapp.title': 'WhatsApp Assistant',
    'land.features.whatsapp.desc': 'Use WhatsApp you already know.',
    'land.benefits.digit.title': 'Digitised format',
    'land.benefits.digit.desc': 'Goodbye paper books; everything is organised.',
    'land.benefits.simple.title': 'Simple UX',
    'land.benefits.simple.desc': 'Made for non-accountants; just fill the basics.',
    'land.benefits.anywhere.title': 'Use anywhere',
    'land.benefits.anywhere.desc': "Works on mobile and desktop; it's on the web.",
    'land.benefits.cloud.title': 'Cloud storage',
    'land.benefits.cloud.desc': 'Your data is safe and accessible when you need it.',
    'land.pricing.free.title': 'Free',
    'land.pricing.free.desc': 'No expiry - use until limits reached',
    'land.pricing.free.b1': 'Orders limit: 100 total',
    'land.pricing.free.b2': 'Expenses limit: 100 total',
    'land.pricing.free.b3': 'Access to business overview',
    'land.pricing.free.cta': 'Start free',
    'land.pricing.pro.title': 'Pro',
    'land.pricing.pro.desc': 'Everything unlimited',
    'land.pricing.pro.price': '₹167',
    'land.pricing.perMonth': '/month',
    'land.pricing.pro.b1': 'Unlimited orders',
    'land.pricing.pro.b2': 'Unlimited expenses',
    'land.pricing.pro.b3': 'Priority support',
    'land.pricing.pro.cta': 'Go Pro',
    'land.pricing.yearly.title': 'Pro',
    'land.pricing.yearly.desc': 'Best value - charged annually',
    'land.pricing.yearly.price': '₹2,000',
    'land.pricing.perYear': '/year',
    'land.pricing.yearly.b1': 'Unlimited orders',
    'land.pricing.yearly.b2': 'Unlimited expenses',
    'land.pricing.yearly.b3': 'Priority support',
    'land.pricing.yearly.b4': 'Save ₹1,997 vs monthly',
    'land.pricing.yearly.cta': 'Save 50%',
    'land.pricing.threeyear.title': 'Pro 3-Year',
    'land.pricing.threeyear.desc': 'Ultimate savings - 3 years',
    'land.pricing.threeyear.price': '₹4,000',
    'land.pricing.threeyear.monthly': '₹111/month',
    'land.pricing.threeyear.original': '₹5,976',
    'land.pricing.threeyear.savings': 'Save 33%',
    'land.pricing.threeyear.b1': 'Unlimited orders',
    'land.pricing.threeyear.b2': 'Unlimited expenses',
    'land.pricing.threeyear.b3': 'Priority support',
    'land.pricing.threeyear.b4': 'Save ₹2,000 vs annual',
    'land.pricing.threeyear.cta': 'Best Deal',
    'land.auth.heading.login': 'Welcome back',
    'land.auth.sub.login': 'Log in to continue',
    'land.auth.heading.signup': 'Create your account',
    'land.auth.sub.signup': 'Verify your phone to continue',
    'land.footer.tagline': 'Simple profit visibility for your business. Update daily, decide confidently.',
    'land.footer.about': 'About',
    'land.footer.product': 'Product',
    'land.footer.legal': 'Legal',
    'land.footer.terms': 'Terms',
    'land.footer.privacy': 'Privacy',
    'land.footer.contact': 'Contact',
    // Language prompt
    'land.prompt.ta.title': 'Switch to Tamil?',
    'land.prompt.ta.desc': 'Your device language supports Tamil. You can switch anytime.',
    'land.prompt.ta.switch': 'Switch to Tamil',
    'land.prompt.ta.dismiss': 'Not now',
    // Login / Signup
    'login.username.placeholder': 'Phone or Email',
    'login.password.placeholder': 'Password',
    'login.password.show': 'Show',
    'login.password.hide': 'Hide',
    'login.submit.idle': 'Log in',
    'login.submit.loading': 'Logging in...',
    'login.cta.create': 'Create account',
    'login.forgot': 'Forgot password? Use WhatsApp to reset',
    'signup.phone.placeholder': 'Phone',
    'signup.business.placeholder': 'Business Name',
    'signup.name.placeholder': 'Your Name',
    'signup.address.placeholder': 'Address',
    'signup.email.placeholder': 'Email',
    'signup.setPassword.placeholder': 'Set Password',
    'signup.confirmPassword.placeholder': 'Confirm Password',
    'signup.password.show': 'Show',
    'signup.password.hide': 'Hide',
    'signup.password.mismatch': 'Passwords do not match',
    'signup.submit.idle': 'Continue & Verify Phone',
    'signup.submit.loading': 'Please wait...',
    'signup.already': 'Already have an account?',
    'signup.login': 'Log in',
    'signup.otp.prompt': 'Enter the 6-digit code sent to your phone',
    'signup.otp.placeholder': '123456',
    'signup.otp.submit.idle': 'Verify & Create Account',
    'signup.otp.submit.loading': 'Verifying...',
    // Expenses
    'exp.title': 'Expenses',
    'exp.add.date': 'Date',
    'exp.add.amount': 'Amount',
    'exp.add.category': 'Category',
    'exp.add.frequency': 'Frequency',
    'exp.add.note.placeholder': 'Note (optional)',
    'exp.add.addExpense': 'Add Expense',
    'exp.freq.daily': 'Daily',
    'exp.freq.monthly': 'Monthly',
    'exp.cat.other': 'Other',
    'exp.cat.rent': 'Rent',
    'exp.cat.electricity': 'Electricity',
    'exp.cat.wages': 'Wages',
    'exp.cat.delivery': 'Delivery',
    'exp.cat.marketing': 'Marketing',
    'exp.recent.title': 'Recent',
    'exp.recent.loading': 'Loading…',
    'exp.recent.empty': 'No expenses added yet',
    'exp.action.edit': 'Edit',
    'exp.action.delete': 'Delete',
    'exp.confirm.delete': 'Delete this expense?',
    'exp.modal.editTitle': 'Edit Expense',
    'exp.modal.save': 'Save',
    'exp.modal.cancel': 'Cancel',
    // Product
    'prod.title': 'Products',
    'prod.add.title': 'Add Product',
    'prod.edit.title': 'Edit Product',
    'prod.field.name': 'Product Name',
    'prod.linked.title': 'Linked Items (Inventory or Other)',
    'prod.linked.placeholder': 'e.g. Electricity',
    'prod.linked.add': '+ Add Item',
    'prod.btn.save': 'Save Product',
    'prod.btn.update': 'Update',
    'prod.btn.cancel': 'Cancel',
    'prod.list.title': 'Products',
    'prod.list.subtitle': 'Each product can link inventory or other cost inputs',
    'prod.list.empty': 'No products yet',
    'prod.list.edit': 'Edit',
    'prod.list.linkCount': '{count} linked item(s)',
    'prod.remove': 'Remove',
    // Orders
    'orders.title': 'Orders',
    'orders.form.editTitle': 'Edit Order',
    'orders.form.newTitle': 'New Order',
    'orders.form.orderName.placeholder': 'Order Name',
    'orders.form.selectCustomer': 'Select Customer',
    'orders.form.selectProductOptional': 'Select Product (Optional)',
    'orders.form.sellingPrice.placeholder': 'Selling Price',
    'orders.form.costItems.label': 'Cost Items',
    'orders.form.costItems.col.name': 'Item',
    'orders.form.costItems.col.qty': 'Qty',
    'orders.form.costItems.col.price': 'Price',
    'orders.form.section.details': 'Order Details',
    'orders.form.field.name': 'Order Name',
    'orders.form.field.selling': 'Selling Price',
    'orders.form.field.date': 'Date',
    'orders.form.field.customer': 'Customer',
    'orders.form.field.product': 'Product',
    'orders.form.addLine': '+ Add Line',
    'orders.form.totalCost': 'Total Cost',
    'orders.form.profit': 'Profit',
    'orders.form.placeOrder': 'Place Order',
    'orders.form.updateOrder': 'Update Order',
    'orders.form.cancelEdit': 'Cancel',
    'orders.form.saving': 'Saving…',
    'orders.form.clear': 'Clear',
    'orders.recent.title': 'Recent Orders',
    'orders.recent.loading': 'Loading…',
    'orders.recent.empty': 'No orders yet.',
    'orders.recent.customOrder': 'Custom Order',
    'orders.recent.costLabel': 'Cost',
    'orders.recent.edit': 'Edit',
    'orders.recent.delete': 'Delete',
    'orders.recent.profitLabel': 'Profit',
    'orders.confirm.delete': 'Delete this order?',
    // Orders filters
    'orders.filter.search.placeholder': 'Search order or customer name',
    'orders.filter.from': 'From',
    'orders.filter.to': 'To',
    'orders.filter.clear': 'Clear filters',
    'orders.filter.title': 'Filter orders',
    'orders.card.labels.selling': 'Sale',
    'orders.card.labels.cost': 'Cost',
    'orders.card.labels.profit': 'Profit',
    // Customers
    'cust.title': 'Customers',
    'cust.add.name': 'Customer Name',
    'cust.add.phone': 'Phone Number *',
    'cust.add.address': 'Address (optional)',
    'cust.add.save': 'Add Customer',
    'cust.list.title': 'Customer List',
    'cust.search.placeholder': 'Search by name, phone or address…',
    'cust.loading': 'Loading…',
    'cust.empty': 'No customers yet',
    'cust.action.edit': 'Edit',
    'cust.action.delete': 'Delete',
    'cust.confirm.delete': 'Delete this customer?',
    'cust.modal.editTitle': 'Edit Customer',
    'cust.modal.save': 'Save',
    'cust.modal.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.cancel': 'Cancel',
    // P&L
    'pl.title': 'Profit & Loss',
    'pl.range.option.today': 'Today',
    'pl.range.option.week': 'Last 7 Days',
    'pl.range.option.month': 'Last 30 Days',
    'pl.range.option.year': 'This Year',
    'pl.range.option.custom': 'Custom',
    'pl.range.label.today': 'Today',
    'pl.range.label.week': 'This Week',
    'pl.range.label.month': 'This Month',
    'pl.range.label.year': 'This Year',
    'pl.range.label.custom': 'Custom',
    'pl.range.to': 'to',
    'pl.range.from': 'From',
    'pl.range.custom.title': 'Custom Date Range',
    'pl.metric.revenue': 'Revenue ({label})',
    'pl.metric.cogs': 'COGS ({label})',
    'pl.metric.expenses': 'Expenses ({label})',
    'pl.metric.gross': 'Gross Profit',
    'pl.metric.net': 'Net Profit',
    'pl.section.how': 'How we calculate',
    'pl.how.revenue': 'Revenue = Sum of your sales (Order selling price)',
    'pl.how.cogs': 'COGS = Cost of goods sold',
    'pl.how.gross': 'Gross Profit = Revenue − COGS',
    'pl.how.netMonthly': 'Net Profit = Gross Profit − Monthly Expenses',
    'pl.how.net': 'Net Profit = Gross Profit − Expenses',
    'pl.ledger.title': 'Ledger ({label})',
    'pl.ledger.empty': 'No entries in this period',
    'pl.ledger.credit': 'Credit',
    'pl.ledger.debit': 'Debit',
    'pl.ledger.sale': 'Sale',
    'pl.ledger.cogs': 'COGS',
    'pl.ledger.expense': 'Expense',
    'pl.section.trend': 'Profit Trend ({label})',
    'pl.tip.title': 'Tip',
    'pl.tip.body': 'Add general expenses (rent, electricity, delivery) to get Net Profit.',
    // P&L paywall
    'pl.paywall.year.title': 'Year P&L on Pro',
    'pl.paywall.year.desc': 'To view Year P&L ledger, become a Pro member.',
    // Dashboard
    'dash.greeting': 'Hi {name},',
    'dash.subtitle': 'Here\'s your update for Today',
    'dash.paywall.title': 'Your free plan has ended',
    'dash.paywall.desc': 'Subscribe to continue using Orders, Product, and P&L.',
    'dash.paywall.subscribe': 'Subscribe yearly',
    'dash.paywall.pending': 'Request submitted',
    'dash.paywall.info': 'Your request is accepted. Our team will reach out to you soon.',
    'dash.card.todaysProfit': "Today's Profit",
    'dash.card.totalProfit': 'Total Profit',
    'dash.card.totalOrders': 'Total Orders',
    'dash.section.weekProfit': 'Profit This Week',
    'dash.section.topProduct': 'Top Product of the Week',
    'dash.topProduct.empty.title': 'No product data yet',
    'dash.topProduct.empty.desc': 'Add products and orders to see insights',
    'dash.topProduct.shareSuffix': 'of revenue',
    'dash.share.todaySummary': 'Share Today\'s Summary',
    'dash.trial.title': 'Become a Pro to unlock full potential',
    'dash.trial.subtitle': 'Unlimited orders, expenses, Year P&L and more.',
    'dash.trial.cta': 'Become Pro',
    'dash.trial.dismiss': 'Not now',
    'dash.info.showing': 'Showing',
    'dash.info.period.week': 'This Week',
    'dash.info.period.today': 'Today',
    'dash.info.year': 'Year: {year}',

    // Reports
    'reports.title': 'Reports',
    'reports.subtitle': 'Analyse your business performance in depth.',
    'reports.offline.title': 'Reporting requires internet',
    'reports.offline.desc': 'Reconnect to refresh insights. Offline data entry is still available.',
    'reports.range.quick': 'Quick ranges',
    'reports.range.global': 'Use dashboard period',
    'reports.range.7d': 'Last 7 days',
    'reports.range.30d': 'Last 30 days',
    'reports.range.fy': 'Current FY',
    'reports.range.custom': 'Custom',
    'reports.field.from': 'From',
    'reports.field.to': 'To',
    'reports.actions.reset': 'Reset',
    'reports.actions.run': 'Run report',
    'reports.filters.orders.products': 'Products',
    'reports.filters.products.placeholder': 'No products yet',
    'reports.filters.orders.customers': 'Customers',
    'reports.filters.customers.placeholder': 'No customers yet',
    'reports.filters.orders.categories': 'Income categories',
    'reports.filters.categories.placeholder': 'No categories yet',
    'reports.filters.expenses.categories': 'Expense categories',
    'reports.filters.expenseCategories.placeholder': 'No expense categories yet',
    'reports.filters.accountScope.account': 'Showing data for selected account',
    'reports.filters.accountScope.org': 'Showing organization-wide data',
    'reports.filters.applied': 'Filters active',
    'reports.filters.none': 'No filters applied',
    'reports.error.generic': 'Failed to load report. Please try again.',
    'reports.summary.revenue': 'Revenue',
    'reports.summary.cost': 'COGS',
    'reports.summary.expenses': 'Expenses',
    'reports.summary.gross': 'Gross Profit',
    'reports.summary.net': 'Net Profit',
    'reports.summary.margin': 'Profit Margin',
    'reports.top.product': 'Top product',
    'reports.top.customer': 'Top customer',
    'reports.top.expenseCategory': 'Top expense category',
    'reports.top.empty': 'No data yet',
    'reports.drilldown.products': 'Top product',
    'reports.drilldown.productsAll': 'All products',
    'reports.drilldown.customers': 'Top customer',
    'reports.drilldown.customersAll': 'All customers',
    'reports.drilldown.expenses': 'Top expense category',
    'reports.drilldown.expensesAll': 'All expense categories',
    'reports.drilldown.pending': 'Cash pending',
    'reports.drilldown.pendingAll': 'All pending customers',
    'reports.drilldown.shareOfRevenue': '{value} of revenue',
    'reports.drilldown.shareOfExpense': '{value} of spend',
    'reports.drilldown.shareOfPending': '{value} of pending',
    'reports.drilldown.none': 'No data yet',
    'reports.drilldown.name': 'Name',
    'reports.drilldown.sales': 'Sales',
    'reports.drilldown.amount': 'Amount',
    'reports.drilldown.pendingAmount': 'Pending',
    'reports.drilldown.orders': 'Orders',
    'reports.drilldown.entries': 'Entries',
    'reports.drilldown.share': 'Share',
    'reports.drilldown.pendingBills': '{pending}/{total} bills pending',
    'reports.drilldown.pendingBillsFallback': '{pending} bills pending',
    'reports.drilldown.collectionRateLabel': 'Collection rate {value}',
    'reports.drilldown.pendingNoData': 'No collection data yet',
    'reports.breakdown.products': 'Products',
    'reports.breakdown.customers': 'Customers',
    'reports.breakdown.incomeCategories': 'Income categories',
    'reports.breakdown.expenseCategories': 'Expense categories',
    'reports.trend.dailyNet': 'Daily net profit',
    'reports.trend.recent': 'Recent days',
    'reports.generatedAt': 'Updated at {time}',
    'reports.cash.heading': 'Cash collections',
    'reports.cash.pending': 'Pending cash',
    'reports.cash.outOf': 'out of {amount}',
    'reports.cash.received': 'Collected',
    'reports.cash.collectionRate': 'Collection rate',
    'reports.cash.pendingOrders': 'Pending bills',
    'reports.cash.settled': 'Settled',
    'reports.cash.empty': 'Create new bills to track cash collections.',
    'reports.cash.customers': 'Customers with pending cash',
    'reports.cash.customers.empty': 'All tracked bills are fully settled.',
    'reports.cash.customerOrders': '{count} bills',
    'reports.cash.ofPending': 'of pending',

    'nav.dashboard': 'Dashboard',
    'nav.reports': 'Reports',
    'nav.pl': 'P&L',
    'nav.fast-billing': 'Fast Billing',
    'nav.invoice-editor': 'Invoice Editor',
    'nav.billing': 'Billing',
    'nav.income': 'Income',
    'nav.expenses': 'Expenses',
    'nav.product': 'Product',
    'nav.products': 'Products',
    'nav.product-management': 'Product Management',
    'nav.customers': 'Customers',
    'nav.categories': 'Categories',
    'nav.business-accounts': 'Business Accounts',
    'nav.accounts': 'Money Accounts',
    'nav.users': 'Users',
    'nav.profile': 'Profile',
    'nav.printer-setup': 'Printer Setup',

    // Accounts
    'acct.title': 'Money Accounts',
    'acct.totalBalance': 'Total Balance',
    'acct.create.name': 'Account Name',
    'acct.create.opening': 'Opening Balance (optional)',
    'acct.create.create': 'Create Account',
    'acct.create.creating': 'Creating…',
    'acct.list.title': 'Your Accounts',
    'acct.list.empty': 'No accounts yet',
    'acct.loading': 'Loading…',
    'acct.balance': 'Balance',
    'acct.view': 'View',
    'acct.reconcile': 'Reconcile',
    'acct.refresh': 'Refresh',
    'acct.transfer.title': 'Transfer Between Accounts',
    'acct.transfer.from': 'From Account',
    'acct.transfer.to': 'To Account',
    'acct.transfer.amount': 'Amount',
    'acct.transfer.note': 'Note (optional)',
    'acct.transfer.move': 'Transfer',
    'acct.transfer.processing': 'Transferring…',
    'acct.ledger.title': 'Ledger',
    'acct.ledger.select': 'Select an account to view ledger',
    'acct.ledger.empty': 'No ledger entries',

    'header.installApp': 'Install App',
    'header.help': 'Help',
    // iOS install guide
    'ios.install.title': 'Install on iPhone',
    'ios.install.step.share': '1) Tap Share in Safari',
    'ios.install.step.add': '2) Choose "Add to Home Screen"',
    'ios.install.tip': 'Then open from your Home Screen like a regular app.',
    'ios.install.close': 'Close',

    'banner.offline.title': "You're offline",
    'banner.offline.subtitle': 'Changes may not save. Please check your internet connection.',
    'banner.offline.retry': 'Retry',

    'profile.profile': 'Profile',
    'profile.logout': 'Logout',

    'tutorial.quickTour': 'Quick Tour',
    'tutorial.welcome.title': 'Welcome to TrackProfit',
    'tutorial.welcome.text': 'This quick 1-minute tour shows you how to track profit, manage orders and expenses.',
    'tutorial.dashboard.title': 'Dashboard Overview',
    'tutorial.dashboard.text': "See today's profit, total profit and orders at a glance. The weekly chart shows recent performance.",
    'tutorial.nav.title': 'Navigation',
    'tutorial.nav.text': 'Click the top menu icon to open the sidebar, then select a section.',
    'tutorial.orders.title': 'Create Orders',
    'tutorial.orders.text': 'Add orders with selling price and cost lines. You can start with a product template, or just add custom cost items.',
    'tutorial.product.title': 'Set Up Products',
    'tutorial.product.text': 'Define products and link their usual cost items (like electricity or packaging). This speeds up order entry.',
    'tutorial.lang.title': 'Switch Language',
    'tutorial.lang.text': 'Use the profile menu (top-right) to switch to Tamil or English.',
    'tutorial.pl.title': 'Profit & Loss',
    'tutorial.pl.text': 'View profit trends and totals. Orders minus costs and expenses give your net profit.',
    'tutorial.expenses.title': 'Record Expenses',
    'tutorial.expenses.text': 'Log daily or periodic expenses. They are included in profit calculations. Tap + Add Expense to add a new expense.',
    'tutorial.customers.title': 'Customers',
    'tutorial.customers.text': 'Manage your customers and their profiles for quick selection in orders.',
    'tutorial.accounts.title': 'Accounts',
    'tutorial.accounts.text': 'View balances, transfer funds, and inspect ledger entries.',
    'tutorial.done.title': "You're all set",
    'tutorial.done.text': 'Start by placing an order or adding an expense. You can replay this tour anytime from the header.',
    'tutorial.skip': 'Skip',
    'tutorial.back': 'Back',
    'tutorial.next': 'Next',
    'tutorial.finish': 'Finish',
  },
  ta: {
    // Landing / Auth
    'land.nav.features': 'அம்சங்கள்',
    'land.nav.pricing': 'விலை',
    'land.nav.login': 'உள்நுழைக',
    'land.nav.startFree': 'இலவசமாக தொடங்கவும்',
    'land.nav.downloads': 'பதிவிறக்கங்கள்',
    'land.hero.badge': 'சிறு தொழில்களுக்கு Profit OS',
    'land.hero.title': 'பில்லிங், செலவுகள் & அறிக்கைகளை ஒரே இடத்தில் இயக்குங்கள்.',
    'land.hero.p1': 'TrackProfit காகித பதிவுகளை மாற்றி, வலை, மொபைல், WhatsApp ஆகியவற்றில் நேரடி லாப டாஷ்போர்டை வழங்குகிறது.',
    'land.hero.p2': 'விற்பனையை வேகமாக முடிக்கவும், பணப்பாய்ச்சலை புரிந்துகொள்ளவும், நிமிடங்களில் முடிவு செய்யவும்.',
    'land.hero.cta.start': 'இலவசமாக தொடங்கவும்',
    'land.hero.cta.login': 'உள்நுழைக',
    'land.hero.cta.whatsapp': 'இலவசமாக WhatsApp தானியங்கியை முயற்சிக்கவும்',
    'land.hero.cta.download': 'ஆப்புகளை பதிவிறக்குக',
    'land.hero.whatsapp.number': '+91 95432 68625',
    'land.hero.whatsapp.demo': 'எப்படி வேலை செய்கிறது பாருங்கள்',
    'land.hero.platform.web': 'வலை டாஷ்போர்ட்',
    'land.hero.platform.android': 'Android APK',
    'land.hero.platform.windows': 'Windows பயன்பாடு',
    'land.hero.platform.whatsapp': 'WhatsApp உதவியாளர்',
    'land.hero.cards.today': 'இன்றைய லாபம்',
    'land.hero.cards.total': 'மொத்த லாபம்',
    'land.hero.cards.orders': 'ஆர்டர்கள்',
    'land.hero.cards.caption': 'உங்கள் கணக்கு பக்கத்தை பாருங்கள்',
    'land.hero.stats.orders': 'இந்த வார ஆர்டர்கள்',
    'land.hero.stats.expenses': 'பதிவான செலவுகள்',
    'land.hero.stats.cash': 'வசூலிக்கப்பட்ட பணம்',
    'land.download.badge': 'புதிய பயன்பாடுகள்',
    'land.download.title': 'Android & Windows க்கான TrackProfit ஐ பதிவிறக்குங்கள்',
    'land.download.subtitle': 'மின்னல் வேக பில்லிங், ஆஃப்லைன் தயாராக இருக்கும் தரவு மற்றும் பிரிண்டர் ஆதரவு ஆகியவற்றிற்கான நேடிவ் அனுபவம்.',
    'land.download.android.badge': 'APK',
    'land.download.android.title': 'Android APK',
    'land.download.android.desc': 'எப்போதும் அசைந்தாடும் தொழில் உரிமையாளர்களுக்கான சிறந்த தேர்வு. ஆஃப்லைனில் பயன்படுத்தி மீண்டும் ஆன்லைனில் ஒத்திசைக்கிறது.',
    'land.download.windows.badge': 'டெஸ்க்டாப்',
    'land.download.windows.title': 'Windows பயன்பாடு (.exe)',
    'land.download.windows.desc': 'கீபோர்ட் குறுக்குவிசைகள் மற்றும் USB/ப்ளூடூத் பிரிண்டர் ஆதரவு கொண்ட முழுத்திறன் அனுபவம்.',
    'land.download.metric.size': 'சுமார் அளவு',
    'land.download.metric.requirement': 'தேவைப்படும்',
    'land.download.cta.android': 'APK பதிவிறக்குக',
    'land.download.cta.windows': 'EXE பதிவிறக்குக',
    'land.download.comingSoon': 'இணைப்பு விரைவில்',
    'land.download.helperSoon': 'அடுத்த வெளியீட்டுக்குப் பிறகு இணைப்பை பகிர்வோம்.',
    'land.download.helper': 'Mac அல்லது iOS வேண்டுமா? WhatsApp-ல் எங்களை தொடர்பு கொள்ளுங்கள்.',
    'land.features.profit.title': 'நேரடி லாபம்',
    'land.features.profit.desc': 'இன்று லாபமா என்பதை பாருங்கள்.',
    'land.features.orders.title': 'ஆர்டர்களை பதிவு செய்யுங்கள்',
    'land.features.orders.desc': 'எளிய ஆர்டர் பதிவு, வேகமாகவும் தெளிவாகவும்.',
    'land.features.expenses.title': 'செலவுகளை பதிவு செய்யுங்கள்',
    'land.features.expenses.desc': 'கணக்குப்பதிவு சிக்கலின்றி உங்கள் செலவுகளை அறியலாம்.',
    'land.features.quick.title': '2–5 நிமி/நாள்',
    'land.features.quick.desc': 'பரிவர்த்தனைகளை தினமும் பதிவு செய்யுங்கள்; கணக்கை நாங்களே செய்கிறோம்.',
    'land.features.whatsapp.title': 'WhatsApp தானியங்கி',
    'land.features.whatsapp.desc': 'உங்களுக்கு தெரிந்த WhatsApp பயன்படுத்துங்கள்.',
    'land.benefits.digit.title': 'மின்மயமாக்கல்',
    'land.benefits.digit.desc': 'காகித புத்தகங்களுக்கு குட்பை; எல்லாம் ஒழுங்காக.',
    'land.benefits.simple.title': 'எளிய பயன்பாடு',
    'land.benefits.simple.desc': 'கணக்காளர்கள் அல்லாதவர்களுக்கான வடிவமைப்பு; அடிப்படைகளை மட்டும் நிரப்புங்கள்.',
    'land.benefits.anywhere.title': 'எங்கும் பயன்படுத்தலாம்',
    'land.benefits.anywhere.desc': 'மொபைல் மற்றும் டெஸ்க்டாப் — இணையத்தில் செயல்படும்.',
    'land.benefits.cloud.title': 'மேக சேமிப்பு',
    'land.benefits.cloud.desc': 'உங்கள் தரவு பாதுகாப்பாகவும் எப்போதும் அணுகக்கூடியதாகவும் இருக்கும்.',
    'land.pricing.free.title': 'இலவசம்',
    'land.pricing.free.desc': 'காலவரம்பு இல்லை - வரம்புகள் வரை பயன்படுத்தவும்',
    'land.pricing.free.b1': 'ஆர்டர்கள் வரம்பு: மொத்தம் 100',
    'land.pricing.free.b2': 'செலவுகள் வரம்பு: மொத்தம் 100',
    'land.pricing.free.b3': 'கணக்கு பக்கம் பார்க்கலாம்',
    'land.pricing.free.cta': 'இலவசமாக தொடங்கவும்',
    'land.pricing.pro.title': 'ப்ரோ',
    'land.pricing.pro.desc': 'அனைத்தும் வரம்பில்லாமல்',
    'land.pricing.pro.price': '₹167',
    'land.pricing.perMonth': '/மாதம்',
    'land.pricing.pro.b1': 'வரம்பில்லா ஆர்டர்கள்',
    'land.pricing.pro.b2': 'வரம்பில்லா செலவுகள்',
    'land.pricing.pro.b3': 'முன்னுரிமை ஆதரவு',
    'land.pricing.pro.cta': 'ப்ரோ-விற்கு மாற்றவும்',
    'land.pricing.yearly.title': 'ப்ரோ',
    'land.pricing.yearly.desc': 'சிறந்த மதிப்பு - ஆண்டுதோறும் வசூலிக்கப்படுகிறது',
    'land.pricing.yearly.price': '₹2,000',
    'land.pricing.perYear': '/ஆண்டு',
    'land.pricing.yearly.b1': 'வரம்பில்லா ஆர்டர்கள்',
    'land.pricing.yearly.b2': 'வரம்பில்லா செலவுகள்',
    'land.pricing.yearly.b3': 'முன்னுரிமை ஆதரவு',
    'land.pricing.yearly.b4': 'மாதாந்திரத்தில் ₹1,997 சேமிக்கவும்',
    'land.pricing.yearly.cta': '50% சேமிக்கவும்',
    'land.pricing.threeyear.title': 'ப்ரோ 3-ஆண்டு',
    'land.pricing.threeyear.desc': 'உச்ச சேமிப்பு - 3 ஆண்டுகள்',
    'land.pricing.threeyear.price': '₹4,000',
    'land.pricing.threeyear.monthly': '₹111/மாதம்',
    'land.pricing.threeyear.original': '₹5,976',
    'land.pricing.threeyear.savings': '33% சேமிக்கவும்',
    'land.pricing.threeyear.b1': 'வரம்பில்லா ஆர்டர்கள்',
    'land.pricing.threeyear.b2': 'வரம்பில்லா செலவுகள்',
    'land.pricing.threeyear.b3': 'முன்னுரிமை ஆதரவு',
    'land.pricing.threeyear.b4': 'ஆண்டு ₹2,000 சேமிக்கவும்',
    'land.pricing.threeyear.cta': 'சிறந்த ஒப்பந்தம்',
    'land.auth.heading.login': 'மீண்டும் வரவேற்கிறோம்',
    'land.auth.sub.login': 'தொடர உள்நுழைக',
    'land.auth.heading.signup': 'உங்கள் கணக்கை உருவாக்கவும்',
    'land.auth.sub.signup': 'தொடர உங்கள் போனை சரிபார்க்கவும்',
    'land.footer.tagline': 'உங்கள் தொழிலுக்கான எளிய லாப காட்சி. தினமும் புதுப்பித்து, நம்பிக்கையுடன் முடிவு செய்யுங்கள்.',
    'land.footer.about': 'பற்றி',
    'land.footer.product': 'தயாரிப்பு',
    'land.footer.legal': 'சட்டம்',
    'land.footer.terms': 'விதிமுறைகள்',
    'land.footer.privacy': 'தனியுரிமை',
    'land.footer.contact': 'தொடர்பு',
    // Language prompt
    'land.prompt.ta.title': 'தமிழுக்கு மாறவா?',
    'land.prompt.ta.desc': 'உங்கள் சாதன மொழி தமிழை ஆதரிக்கிறது. நீங்கள் எப்போது வேண்டுமானாலும் மாற்றலாம்.',
    'land.prompt.ta.switch': 'தமிழுக்கு மாறு',
    'land.prompt.ta.dismiss': 'இப்போது வேண்டாம்',
    // Login / Signup
    'login.username.placeholder': 'போன் அல்லது மின்னஞ்சல்',
    'login.password.placeholder': 'கடவுச்சொல்',
    'login.password.show': 'காட்டு',
    'login.password.hide': 'மறை',
    'login.submit.idle': 'உள்நுழைக',
    'login.submit.loading': 'உள்நுழைகிறது...',
    'login.cta.create': 'கணக்கை உருவாக்கவும்',
    'login.forgot': 'கடவுச்சொல் மறந்ததா? WhatsApp மூலம் மீட்டெடுக்கவும்',
    'signup.phone.placeholder': 'போன்',
    'signup.business.placeholder': 'தொழில் பெயர்',
    'signup.name.placeholder': 'உங்கள் பெயர்',
    'signup.address.placeholder': 'முகவரி',
    'signup.email.placeholder': 'மின்னஞ்சல்',
    'signup.setPassword.placeholder': 'கடவுச்சொல் அமைக்கவும்',
    'signup.confirmPassword.placeholder': 'கடவுச்சொல்லை உறுதிப்படுத்தவும்',
    'signup.password.show': 'காட்டு',
    'signup.password.hide': 'மறை',
    'signup.password.mismatch': 'கடவுச்சொற்கள் பொருந்தவில்லை',
    'signup.submit.idle': 'தொடர & போனை சரிபார்க்கவும்',
    'signup.submit.loading': 'தயவுசெய்து காத்திருக்கவும்...',
    'signup.already': 'ஏற்கனவே கணக்கு உள்ளதா?',
    'signup.login': 'உள்நுழைக',
    'signup.otp.prompt': 'உங்கள் போனுக்கு அனுப்பிய 6 இலக்கக் குறியீட்டை உள்ளிடவும்',
    'signup.otp.placeholder': '123456',
    'signup.otp.submit.idle': 'உறுதிப்படுத்து & கணக்கை உருவாக்கு',
    'signup.otp.submit.loading': 'உறுதிப்படுத்துகிறது...',
    // Expenses
    'exp.title': 'செலவுகள்',
    'exp.add.date': 'தேதி',
    'exp.add.amount': 'தொகை',
    'exp.add.category': 'வகை',
    'exp.add.frequency': 'அடிக்கடி',
    'exp.add.note.placeholder': 'குறிப்பு (விருப்பம்)',
    'exp.add.addExpense': 'செலவைச் சேர்க்கவும்',
    'exp.freq.daily': 'தினசரி',
    'exp.freq.monthly': 'மாதாந்திர',
    'exp.cat.other': 'மற்றவை',
    'exp.cat.rent': 'வாடகம்',
    'exp.cat.electricity': 'மின்சாரம்',
    'exp.cat.wages': 'ஊதியம்',
    'exp.cat.delivery': 'டெலிவரி',
    'exp.cat.marketing': 'மார்க்கெட்டிங்',
    'exp.recent.title': 'சமீபத்திய',
    'exp.recent.loading': 'ஏற்றுகிறது…',
    'exp.recent.empty': 'இன்னும் செலவுகள் இல்லை',
    'exp.action.edit': 'திருத்த',
    'exp.action.delete': 'அழி',
    'exp.confirm.delete': 'இந்த செலவை அழிக்கவா?',
    'exp.modal.editTitle': 'செலவைத் திருத்தவும்',
    'exp.modal.save': 'சேமிக்க',
    'exp.modal.cancel': 'ரத்து செய்',
    
    // Product (TA)
    'prod.title': 'பொருட்கள்',
    'prod.add.title': 'பொருளைச் சேர்க்கவும்',
    'prod.edit.title': 'பொருளைத் திருத்தவும்',
    'prod.field.name': 'பொருளின் பெயர்',
    'prod.linked.title': 'இணைக்கப்பட்ட உருப்படிகள் (சரக்கு அல்லது பிற)',
    'prod.linked.placeholder': 'உர்: மின்சாரம்',
    'prod.linked.add': '+ உருப்படியைச் சேர்க்கவும்',
    'prod.btn.save': 'பொருளை சேமிக்கவும்',
    'prod.btn.update': 'புதுப்பிக்கவும்',
    'prod.btn.cancel': 'ரத்து செய்',
    'prod.list.title': 'பொருட்கள்',
    'prod.list.subtitle': 'ஒவ்வொரு பொருளும் சரக்கு அல்லது பிற செலவு உள்ளீடுகளை இணைக்க முடியும்',
    'prod.list.empty': 'பொருட்கள் எதுவும் இல்லை',
    'prod.list.edit': 'திருத்த',
    'prod.list.linkCount': '{count} இணைக்கப்பட்ட உருப்படி(கள்)',
    'prod.remove': 'அகற்று',
    // Orders
    'orders.title': 'ஆர்டர்கள்',
    'orders.form.editTitle': 'ஆர்டரை திருத்தவும்',
    'orders.form.newTitle': 'புதிய ஆர்டர்',
    'orders.form.orderName.placeholder': 'ஆர்டர் பெயர்',
    'orders.form.selectCustomer': 'வாடிக்கையாளரைத் தேர்ந்தெடுக்கவும்',
    'orders.form.selectProductOptional': 'பொருளைத் தேர்வு செய்யவும் (விருப்பம்)',
    'orders.form.sellingPrice.placeholder': 'விற்பனை விலை',
    'orders.form.costItems.label': 'செலவு உருப்படிகள்',
    'orders.form.costItems.col.name': 'உருப்படி',
    'orders.form.costItems.col.qty': 'அளவு',
    'orders.form.costItems.col.price': 'விலை',
    'orders.form.section.details': 'ஆர்டர் விவரங்கள்',
    'orders.form.field.name': 'ஆர்டர் பெயர்',
    'orders.form.field.selling': 'விற்பனை விலை',
    'orders.form.field.date': 'தேதி',
    'orders.form.field.customer': 'வாடிக்கையாளர்',
    'orders.form.field.product': 'பொருள்',
    'orders.form.addLine': '+ உருப்படியைச் சேர்க்கவும்',
    'orders.form.totalCost': 'மொத்த செலவு',
    'orders.form.profit': 'லாபம்',
    'orders.form.placeOrder': 'ஆர்டரை இடு',
    'orders.form.updateOrder': 'ஆர்டரைப் புதுப்பிக்கவும்',
    'orders.form.cancelEdit': 'ரத்து செய்',
    'orders.form.saving': 'சேமிக்கிறது…',
    'orders.form.clear': 'நீக்கு',
    'orders.recent.title': 'சமீபத்திய ஆர்டர்கள்',
    'orders.recent.loading': 'ஏற்றுகிறது…',
    'orders.recent.empty': 'ஆர்டர்கள் எதுவும் இல்லை.',
    'orders.recent.customOrder': 'தனிப்பயன் ஆர்டர்',
    'orders.recent.costLabel': 'செலவு',
    'orders.recent.edit': 'திருத்த',
    'orders.recent.delete': 'அழி',
    'orders.recent.profitLabel': 'லாபம்',
    'orders.confirm.delete': 'இந்த ஆர்டரை அழிக்கவா?',
    // Orders filters (TA)
    'orders.filter.search.placeholder': 'ஆர்டர் அல்லது வாடிக்கையாளர் பெயர்',
    'orders.filter.from': 'இருந்து',
    'orders.filter.to': 'வரை',
    'orders.filter.clear': 'வடிப்பான்களை நீக்கு',
    'orders.filter.title': 'ஆர்டர்கள் வடிகட்டி',
    'orders.card.labels.selling': 'விற்பனை',
    'orders.card.labels.cost': 'செலவு',
    'orders.card.labels.profit': 'லாபம்',
    // Customers (TA)
    'cust.title': 'வாடிக்கையாளர்கள்',
    'cust.add.name': 'வாடிக்கையாளர் பெயர்',
    'cust.add.phone': 'போன் எண் *',
    'cust.add.address': 'முகவரி (விருப்பம்)',
    'cust.add.save': 'வாடிக்கையாளரைச் சேர்க்கவும்',
    'cust.list.title': 'வாடிக்கையாளர் பட்டியல்',
    'cust.search.placeholder': 'பெயர், போன் அல்லது முகவரி மூலம் தேடுங்கள்…',
    'cust.loading': 'ஏற்றுகிறது…',
    'cust.empty': 'இன்னும் வாடிக்கையாளர்கள் இல்லை',
    'cust.action.edit': 'திருத்த',
    'cust.action.delete': 'அழி',
    'cust.confirm.delete': 'இந்த வாடிக்கையாளரை அழிக்கவா?',
    'cust.modal.editTitle': 'வாடிக்கையாளரைத் திருத்தவும்',
    'cust.modal.save': 'சேமிக்க',
    'cust.modal.cancel': 'ரத்து செய்',
    // P&L
    'pl.title': 'லாப நஷ்டம்',
    'pl.range.option.today': 'இன்று',
    'pl.range.option.week': 'கடந்த 7 நாட்கள்',
    'pl.range.option.month': 'கடந்த 30 நாட்கள்',
    'pl.range.option.year': 'இந்த ஆண்டு',
    'pl.range.option.custom': 'Custom',
    'pl.range.label.today': 'இன்று',
    'pl.range.label.week': 'இந்த வாரம்',
    'pl.range.label.month': 'இந்த மாதம்',
    'pl.range.label.year': 'இந்த ஆண்டு',
    'pl.range.label.custom': 'Custom',
    'pl.range.to': 'to',
    'pl.range.from': 'From',
    'pl.range.custom.title': 'Custom Date Range',
    'pl.metric.revenue': 'வருவாய் ({label})',
    'pl.metric.cogs': 'உற்பத்தி செலவு (COGS) ({label})',
    'pl.metric.expenses': 'செலவுகள் ({label})',
    'pl.metric.gross': 'மொத்த லாபம்',
    'pl.metric.net': 'நிகர லாபம்',
    'pl.section.how': 'எப்படி கணக்கிடுகிறோம்',
    'pl.how.revenue': 'வருவாய் = உங்கள் விற்பனை (ஆர்டர் விற்பனை விலை) கூட்டுத்தொகை',
    'pl.how.cogs': 'COGS = விற்ற பொருட்களின் செலவு',
    'pl.how.gross': 'மொத்த லாபம் = வருவாய் − COGS',
    'pl.how.netMonthly': 'நிகர லாபம் = மொத்த லாபம் − மாதாந்திர செலவுகள்',
    'pl.how.net': 'நிகர லாபம் = மொத்த லாபம் − செலவுகள்',
    'pl.ledger.title': 'லெட்ஜர் ({label})',
    'pl.ledger.empty': 'இந்த காலத்தில் பதிவுகள் இல்லை',
    'pl.ledger.credit': 'கிரெடிட்',
    'pl.ledger.debit': 'டெபிட்',
    'pl.ledger.sale': 'விற்பனை',
    'pl.ledger.cogs': 'COGS',
    'pl.ledger.expense': 'செலவு',
    'pl.section.trend': 'லாப போக்கு ({label})',
    'pl.tip.title': 'குறிப்பு',
    'pl.tip.body': 'நிகர லாபத்தைக் காண பொதுச் செலவுகளை (வாடகம், மின்சாரம், டெலிவரி) சேர்க்கவும்.',
    // P&L paywall
    'pl.paywall.year.title': 'ப்ரோவில் மட்டும் ஆண்டு P&L',
    'pl.paywall.year.desc': 'ஆண்டு P&L லெட்ஜரைப் பார்க்க, Pro உறுப்பினராகுங்கள்.',
    // Dashboard
    'dash.greeting': 'வணக்கம் {name},',
    'dash.subtitle': 'இன்றைய புதுப்பிப்புகள் இங்கே',
    'dash.paywall.title': 'உங்கள் இலவச திட்டம் முடிந்துவிட்டது',
    'dash.paywall.desc': 'Orders, Product மற்றும் P&L-ஐ தொடர்ந்து பயன்படுத்த சந்தா செலுத்துங்கள்.',
    'dash.paywall.subscribe': 'வருட சந்தா',
    'dash.paywall.pending': 'கோரிக்கை சமர்ப்பிக்கப்பட்டது',
    'dash.paywall.info': 'உங்கள் கோரிக்கை பெறப்பட்டது. எங்கள் குழு WhatsApp மூலம் விரைவில் தொடர்புகொள்ளும்.',
    'dash.card.todaysProfit': 'இன்றைய லாபம்',
    'dash.card.totalProfit': 'மொத்த லாபம்',
    'dash.card.totalOrders': 'மொத்த ஆர்டர்கள்',
    'dash.section.weekProfit': 'இந்த வார லாபம்',
    'dash.section.topProduct': 'இந்த வாரத்தின் சிறந்த பொருள்',
    'dash.topProduct.empty.title': 'இன்னும் தயாரிப்பு தரவு இல்லை',
    'dash.topProduct.empty.desc': 'உள்ளடக்கங்களைப் பார்க்க பொருட்கள் மற்றும் ஆர்டர்களைச் சேர்க்கவும்',
    'dash.topProduct.shareSuffix': 'வருமானத்தில்',
    'dash.share.todaySummary': 'இன்றைய சுருக்கத்தை பகிரவும்',
    'dash.trial.title': 'முழு திறனைத் திறக்க Pro ஆகுங்கள்',
    'dash.trial.subtitle': 'வரம்பில்லா ஆர்டர்கள், செலவுகள், ஆண்டு P&L மற்றும் பல.',
    'dash.trial.cta': 'Pro ஆகுங்கள்',
    'dash.trial.dismiss': 'பிறகு',
    'dash.info.showing': 'காட்டப்படுகிறது',
    'dash.info.period.week': 'இந்த வாரம்',
    'dash.info.period.today': 'இன்று',
    'dash.info.year': 'ஆண்டு: {year}',

    // Reports (TA)
    'reports.title': 'அறிக்கைகள்',
    'reports.subtitle': 'உங்கள் வணிக செயல்திறனை ஆழமாக பகுப்பாய்வு செய்யுங்கள்.',
    'reports.offline.title': 'அறிக்கைக்கு இணையம் தேவை',
    'reports.offline.desc': 'பார்வைகளைப் புதுப்பிக்க இணையத்தை மீண்டும் இணைக்கவும். ஆஃப்லைன் உள்ளீடுகள் தொடரும்.',
    'reports.range.quick': 'விரைவு காலத் தேர்வுகள்',
    'reports.range.global': 'டாஷ்போர்டு காலத்தைப் பயன்படுத்தவும்',
    'reports.range.7d': 'கடைசி 7 நாட்கள்',
    'reports.range.30d': 'கடைசி 30 நாட்கள்',
    'reports.range.fy': 'நடப்பு நிதியாண்டு',
    'reports.range.custom': 'விருப்பம்',
    'reports.field.from': 'தொடக்கம்',
    'reports.field.to': 'முடிவு',
    'reports.actions.reset': 'மீட்டமை',
    'reports.actions.run': 'அறிக்கையை இயக்கு',
    'reports.filters.orders.products': 'பொருட்கள்',
    'reports.filters.products.placeholder': 'இன்னும் பொருட்கள் இல்லை',
    'reports.filters.orders.customers': 'வாடிக்கையாளர்கள்',
    'reports.filters.customers.placeholder': 'இன்னும் வாடிக்கையாளர்கள் இல்லை',
    'reports.filters.orders.categories': 'வருமான வகைகள்',
    'reports.filters.categories.placeholder': 'No categories yet',
    'reports.filters.expenses.categories': 'Expense categories',
    'reports.filters.expenseCategories.placeholder': 'No expense categories yet',
    'reports.filters.accountScope.account': 'தேர்ந்தெடுத்த கணக்கின் தரவு காட்டப்படுகிறது',
    'reports.filters.accountScope.org': 'நிறுவனம் முழுவதும் உள்ள தரவு காட்டப்படுகிறது',
    'reports.filters.applied': 'வடிகட்டல்கள் செயலில்',
    'reports.filters.none': 'வடிகட்டல்கள் இல்லை',
    'reports.error.generic': 'அறிக்கையை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    'reports.summary.revenue': 'வருமானம்',
    'reports.summary.cost': 'COGS',
    'reports.summary.expenses': 'செலவுகள்',
    'reports.summary.gross': 'மொத்த லாபம்',
    'reports.summary.net': 'நிகர லாபம்',
    'reports.summary.margin': 'லாப விகிதம்',
    'reports.top.product': 'சிறந்த பொருள்',
    'reports.top.customer': 'சிறந்த வாடிக்கையாளர்',
    'reports.top.expenseCategory': 'அதிக செலவு வகை',
    'reports.top.empty': 'தரவு இல்லை',
    'reports.drilldown.products': 'சிறந்த பொருள்',
    'reports.drilldown.productsAll': 'அனைத்து பொருட்கள்',
    'reports.drilldown.customers': 'சிறந்த வாடிக்கையாளர்',
    'reports.drilldown.customersAll': 'அனைத்து வாடிக்கையாளர்கள்',
    'reports.drilldown.expenses': 'முக்கிய செலவுக் வகை',
    'reports.drilldown.expensesAll': 'அனைத்து செலவுக் வகைகள்',
    'reports.drilldown.pending': 'நிலுவை பணம்',
    'reports.drilldown.pendingAll': 'அனைத்து நிலுவை வாடிக்கையாளர்கள்',
    'reports.drilldown.shareOfRevenue': '{value} வருமானத்தில்',
    'reports.drilldown.shareOfExpense': '{value} செலவில்',
    'reports.drilldown.shareOfPending': '{value} நிலுவையில்',
    'reports.drilldown.none': 'தரவு இல்லை',
    'reports.drilldown.name': 'பெயர்',
    'reports.drilldown.sales': 'விற்பனை',
    'reports.drilldown.amount': 'தொகை',
    'reports.drilldown.pendingAmount': 'நிலுவை',
    'reports.drilldown.orders': 'ஆர்டர்கள்',
    'reports.drilldown.entries': 'பதிவுகள்',
    'reports.drilldown.share': 'பங்கு',
    'reports.drilldown.pendingBills': '{pending}/{total} பில்கள் நிலுவையில்',
    'reports.drilldown.pendingBillsFallback': '{pending} பில்கள் நிலுவையில்',
    'reports.drilldown.collectionRateLabel': 'வசூல் விகிதம் {value}',
    'reports.drilldown.pendingNoData': 'நிலுவை தரவு இல்லை',
    'reports.breakdown.products': 'பொருட்கள்',
    'reports.breakdown.customers': 'வாடிக்கையாளர்கள்',
    'reports.breakdown.incomeCategories': 'வருமான வகைகள்',
    'reports.breakdown.expenseCategories': 'செலவு வகைகள்',
    'reports.trend.dailyNet': 'தினசரி நிகர லாபம்',
    'reports.trend.recent': 'சமீபத்திய நாட்கள்',
    'reports.generatedAt': '{time} அன்று புதுப்பிக்கப்பட்டது',
    'reports.cash.heading': 'பணம் வசூல் நிலை',
    'reports.cash.pending': 'நிலுவை பணம்',
    'reports.cash.outOf': 'மொத்தம் {amount}',
    'reports.cash.received': 'வசூலிக்கப்பட்டது',
    'reports.cash.collectionRate': 'வசூல் விகிதம்',
    'reports.cash.pendingOrders': 'நிலுவை விலைப்பட்டியல்',
    'reports.cash.settled': 'நிறைவு',
    'reports.cash.empty': 'பணம் வசூலைக் காண புதிய பில்களை உருவாக்குங்கள்.',
    'reports.cash.customers': 'நிலுவை உள்ள வாடிக்கையாளர்கள்',
    'reports.cash.customers.empty': 'பதிவு செய்யப்பட்ட அனைத்து பில்களும் நிறைவு பெற்றுள்ளன.',
    'reports.cash.customerOrders': '{count} பில்கள்',
    'reports.cash.ofPending': 'நிலுவையில்',

    'nav.dashboard': 'கணக்கு பக்கம்',
    'nav.reports': 'அறிக்கைகள்',
    'nav.pl': 'P&L',
    'nav.fast-billing': 'விரைவு பில்',
    'nav.invoice-editor': 'விலைப்பட்டியல் திருத்தி',
    'nav.billing': 'பில் பதிவுகள்',
    'nav.income': 'வருமானம்',
    'nav.expenses': 'செலவுகள்',
    'nav.product': 'பொருள்',
    'nav.products': 'பொருட்கள்',
    'nav.product-management': 'பொருள் மேலாண்மை',
    'nav.customers': 'வாடிக்கையாளர்கள்',
    'nav.categories': 'வகைகள்',
    'nav.business-accounts': 'வணிக கணக்குகள்',
    'nav.accounts': 'பண கணக்குகள்',
    'nav.users': 'பயனர்கள்',
    'nav.profile': 'சுயவிவரம்',
    'nav.printer-setup': 'அச்சுப்பொறி அமைப்பு',

    // Accounts (TA)
    'acct.title': 'பண கணக்குகள்',
    'acct.totalBalance': 'மொத்த இருப்பு',
    'acct.create.name': 'கணக்கின் பெயர்',
    'acct.create.opening': 'துவக்க இருப்பு (விருப்பம்)',
    'acct.create.create': 'கணக்கை உருவாக்கவும்',
    'acct.create.creating': 'உருவாக்குகிறது…',
    'acct.list.title': 'உங்கள் கணக்குகள்',
    'acct.list.empty': 'கணக்குகள் எதுவும் இல்லை',
    'acct.loading': 'ஏற்றுகிறது…',
    'acct.balance': 'இருப்பு',
    'acct.view': 'பார்க்க',
    'acct.reconcile': 'சரிசெய்',
    'acct.refresh': 'புதுப்பி',
    'acct.transfer.title': 'கணக்குகளுக்கு இடையில் மாற்று',
    'acct.transfer.from': 'எந்த கணக்கில் இருந்து',
    'acct.transfer.to': 'எந்த கணக்குக்கு',
    'acct.transfer.amount': 'தொகை',
    'acct.transfer.note': 'குறிப்பு (விருப்பம்)',
    'acct.transfer.move': 'மாற்று',
    'acct.transfer.processing': 'மாற்றுகிறது…',
    'acct.ledger.title': 'லெட்ஜர்',
    'acct.ledger.select': 'லெட்ஜரை பார்க்க கணக்கைத் தேர்ந்தெடுக்கவும்',
    'acct.ledger.empty': 'லெட்ஜர் பதிவுகள் இல்லை',

    'header.installApp': 'பயன்பாட்டை நிறுவு',
    'header.help': 'உதவி',
    // iOS install guide
    'ios.install.title': 'iPhone-இல் நிறுவவும்',
    'ios.install.step.share': '1) Safari-இல் Share பொத்தானை தட்டவும்',
    'ios.install.step.add': '2) "Add to Home Screen" ஐத் தேர்ந்தெடுக்கவும்',
    'ios.install.tip': 'பிறகு Home Screen-லிருந்து சாதாரண பயன்பாடு போல திறக்கலாம்.',
    'ios.install.close': 'மூடு',

    'banner.offline.title': 'நீங்கள் ஆஃப்லைன் நிலையில் உள்ளீர்கள்',
    'banner.offline.subtitle': 'மாற்றங்கள் சேமிக்கப்படாமல் இருக்கலாம். உங்கள் இணைய இணைப்பை சரிபார்க்கவும்.',
    'banner.offline.retry': 'மீண்டும் முயற்சி',

    'profile.profile': 'சுயவிவரம்',
    'profile.logout': 'வெளியேறு',

    'tutorial.quickTour': 'விரைவு வழிகாட்டி',
    'tutorial.welcome.title': 'TrackProfit-க்கு வரவேற்கிறோம்',
    'tutorial.welcome.text': 'இந்த 1 நிமிட சுற்றுலா லாபத்தை கண்காணிப்பது, ஆர்டர்கள் மற்றும் செலவுகளை நிர்வகிப்பது எப்படி என்பதை காட்டும்.',
    'tutorial.dashboard.title': 'கணக்கு பக்கம்',
    'tutorial.dashboard.text': 'இன்றைய லாபம், மொத்த லாபம், ஆர்டர்கள் — எல்லாம் ஒரே இடத்திலே பார்க்கலாம்.',
    'tutorial.nav.title': 'வழிசெலுத்தல்',
    'tutorial.nav.text': 'மேல் இடது மூலையில் உள்ள மெனு ஐகானை தட்டி சைட்பாரை திறந்து, பகுதிகளைத் தேர்ந்தெடுக்கவும்.',
    'tutorial.customers.title': 'வாடிக்கையாளர்கள்',
    'tutorial.customers.text': 'ஆர்டர்களில் விரைவாகத் தேர்வு செய்ய வாடிக்கையாளர்களையும் அவர்களின் விவரங்களையும் நிர்வகிக்கவும்.',
    'tutorial.accounts.title': 'கணக்குகள்',
    'tutorial.accounts.text': 'இருப்புகளைப் பார்க்க, நிதி மாற்றவும், லெட்ஜர் பதிவுகளை ஆய்வு செய்யவும்.',
    'tutorial.orders.title': 'ஆர்டர் உருவாக்குதல்',
    'tutorial.orders.text': 'விற்பனை விலை மற்றும் செலவு வரிகளுடன் ஆர்டர்களைச் சேர்க்கவும். தயாரிப்பு வார்ப்புருவைத் தொடங்கவோ அல்லது தனிப்பயன் செலவுகளைச் சேர்க்கவோ முடியும்.',
    'tutorial.product.title': 'பொருள் அமைப்பு',
    'tutorial.product.text': 'பொருட்களை வரையறுத்து வழக்கமான செலவுகளை இணைக்கவும். இது ஆர்டர் சேர்ப்பதை வேகப்படுத்தும்.',
    'tutorial.lang.title': 'மொழியை மாற்றவும்',
    'tutorial.lang.text': 'மேல்புற வலது மூலையில் உள்ள சுயவிவர பட்டியலில் தமிழ் அல்லது ஆங்கிலத்தைத் தேர்ந்தெடுக்கலாம்.',
    'tutorial.pl.title': 'லாப நஷ்டம்',
    'tutorial.pl.text': 'லாப நிலை மற்றும் போக்குகளைப் பாருங்கள். ஆர்டர்களிலிருந்து செலவுகள் மற்றும் பிற செலவுகளை கழித்ததே உங்கள் நிகர லாபம்.',
    'tutorial.expenses.title': 'செலவுகள்',
    'tutorial.expenses.text': 'தினசரி அல்லது காலகட்ட செலவுகளை பதிவு செய்யுங்கள். அவை லாபக் கணக்கில் சேர்க்கப்படும்.',
    'tutorial.done.title': 'அனைத்தும் தயாராக உள்ளது',
    'tutorial.done.text': 'ஒரு ஆர்டரை இடுவது அல்லது ஒரு செலவைச் சேர்ப்பதிலிருந்து தொடங்கலாம். இந்த சுற்றுலாவை எப்போதும் தலைப்பிலிருந்து மீண்டும் பார்க்கலாம்.',
    'tutorial.skip': 'தவிர்க்க',
    'tutorial.back': 'பின்',
    'tutorial.next': 'அடுத்து',
    'tutorial.finish': 'முடித்து',
  },
};

export function I18nProvider({ children }) {
  const initial = (() => {
    try { return localStorage.getItem('tp_lang') || 'en'; } catch { return 'en'; }
  })();
  const [lang, setLangState] = useState(initial);
  const setLang = (l) => {
    setLangState(l);
    try { localStorage.setItem('tp_lang', l); } catch {}
  };

  const t = (key) => {
    const pack = dict[lang] || dict.en;
    return pack[key] || dict.en[key] || key;
  };

  const value = useMemo(() => ({ t, lang, setLang }), [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}


